import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CompanyContextProvider } from './Context/CompanyContext';
import { AuthContextProvider } from './Context/AuthContext';
import { ThemeContextProvider } from './Context/ThemeContext';
import { BrowserRouter } from 'react-router-dom';
import { AxiosInterceptor } from './Helper/axios_helper';
import { SocketContextProvider } from './Context/SocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const queryClient = new QueryClient();

root.render(
  <React.Fragment>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <QueryClientProvider client={queryClient}>
          <CompanyContextProvider>
            <AuthContextProvider>
              <ThemeContextProvider>
                <AxiosInterceptor>
                  <SocketContextProvider>
                    <App />
                  </SocketContextProvider>
                </AxiosInterceptor>
              </ThemeContextProvider>
            </AuthContextProvider>
          </CompanyContextProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </CookiesProvider>
  </React.Fragment>,
);
